<!-- display-mobile-14 preview — a bordered 300x250 medium rectangle in the
     middle of a publisher page: the creative on top, and under it a card with
     the headline, the description and an advertiser/action footer. -->
<app-mobile-frame>
  <app-display-browser-chrome frameTop></app-display-browser-chrome>

  <!-- START: Publisher page -->
  <div class="da-page">
    <!-- Article text the ad is embedded in -->
    <div class="da-bars d-flex flex-column">
      <span
        *ngFor="let bar of topBars; let last = last"
        class="da-bar placeholder"
        [class.da-bar-short]="last"
      ></span>
    </div>

    <!-- START: Real ad -->
    <div class="da-ad d-flex flex-column">
      <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-creative">
        <img *ngIf="creativeImage" class="da-creative-image" [src]="creativeImage" alt="" />
        <div *ngIf="!creativeImage" class="da-creative-image creative-missing">{{ missingDimensionLabel }}</div>

        <span class="da-adchoices d-flex align-items-center justify-content-center">
          <i class="bi bi-info-circle"></i>
        </span>
      </a>

      <div class="da-card d-flex flex-column">
        <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-headline">
          {{ data.headlines[0] || "Your headline appears here" }}
        </a>

        <div class="da-desc">
          {{ data.descriptions[0] || "Your description appears here" }}
        </div>

        <div class="da-footer d-flex flex-row align-items-baseline">
          <!-- GenSingleImagePreviewData carries no advertiser field, so the name
               is a literal here, the same compromise the other placements make. -->
          <span class="da-advertiser">Valamar</span>

          <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-cta ms-auto d-flex align-items-center">
            <span class="da-cta-label">{{ data.ctaText || "Your call to action" }}</span>
            <i class="bi bi-chevron-right"></i>
          </a>
        </div>
      </div>
    </div>
    <!-- END: Real ad -->

    <!-- Article text continuing below the ad; the last rows clip at the frame -->
    <div class="da-bars d-flex flex-column">
      <span *ngFor="let bar of bottomBars" class="da-bar placeholder"></span>
    </div>
  </div>
  <!-- END: Publisher page -->
</app-mobile-frame>
